import React from 'react';
import { useAuth } from './AuthContext';
import { useNavigate } from 'react-router-dom';

const NotAuthorized: React.FC = () => {
  const { logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async (): Promise<void> => {
    await logout();
    navigate('/login');
  };

  return (
    <div className="container">
      <div className="row justify-content-center mt-5">
        <div className="col-md-8">
          <div className="card shadow">
            <div className="card-body text-center p-5">
              <h2 className="card-title mb-4">Access Denied</h2>
              <p className="card-text mb-4">
                You are not authorized to access this application. Please contact your administrator to assign you the required BtAddressApp role.
              </p>
              <button 
                onClick={handleLogout}
                className="btn btn-primary"
              >
                <i className="bi bi-box-arrow-right me-1"></i>
                Logout
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotAuthorized;
